export default __webpack_public_path__ + "static/header-contact-d757e254e02ca67431f7681fc9afbab6.jpg";